// The highest resolution of data available from the API is 1 hour.
// Refetching every 5 minutes is more than enough.
export const REFETCH_INTERVAL = 300_000;
